import { Route } from '@app/core/enums/route.enum';
import { Action, ActionName, ActionRoute } from '@app/actions/action.types';

export function getActionRouteCommands(action: Action): ActionRoute | null {
    const { name, data } = action;

    switch (name) {
        case ActionName.UploadNationalIdCard:
            return { commands: [Route.Documents, Route.Upload, Route.NationalId, data.documentTypeId!] };
        case ActionName.UploadBankCard:
            return { commands: [Route.Documents, Route.Upload, Route.BankCard, data.documentTypeId!] };
        case ActionName.UploadDriversLicense:
            return { commands: [Route.Documents, Route.Upload, Route.DriversLicense, data.documentTypeId!] };
        case ActionName.UploadDocument:
            return { commands: [Route.Documents, Route.Upload, data.documentTypeId!] };
        case ActionName.UploadDocumentWithSelector:
            return { commands: [Route.Documents, Route.DocumentSelector, data.documentTypeId!] };
        case ActionName.SignDocument:
            return { commands: [Route.Documents, data.documentId!, Route.Sign] };
        case ActionName.ApproveDocument:
            return { commands: [Route.Documents, data.documentId!, Route.Approve] };
        case ActionName.ViewDocument:
            return { commands: [Route.Documents, data.documentId!] };
        case ActionName.CompletePersonalData:
            return { commands: [Route.ProfileWizard] };
        case ActionName.FinancialContact:
            return { commands: [Route.Financial] };
        case ActionName.EmergencyContact:
            return { commands: [Route.EmergencyContact] };
        case ActionName.Company:
            return { commands: [Route.Company] };
        case ActionName.Housing:
            return { commands: [Route.MyHousing] };
        case ActionName.AppliedJobs:
            return { commands: [Route.Jobs, Route.Applied] };
        case ActionName.ShiftDetail:
            return { commands: [Route.Shifts, data.shiftId!] };
        case ActionName.EventCalendarDaySelected:
            return { commands: [Route.EventCalendar], queryParams: { date: data.day! } };
        case ActionName.EventCalendarShiftDetail:
            return { commands: [Route.EventCalendar, Route.Shifts, data.shiftId!] };
        case ActionName.EventCalendarEngagementDetail:
            return { commands: [Route.EventCalendar, Route.Engagements, data.engagementId!] };
        case ActionName.OpenAppointment:
            return { commands: [Route.EventCalendar, Route.Appointment, data.appointmentId!] };
        case ActionName.NewChatMessage:
            return { commands: [Route.Dashboard, Route.Chat, data.chatAgentExternalId!] };
        case ActionName.InboxMessage:
            return { commands: [Route.MyInbox] };
        case ActionName.OpenTimeRegistrationWeek:
            return { commands: [Route.TimeRegistration], queryParams: { year: data.year!, weekNumber: data.weekNumber! } };
        default:
            return null;
    }
}
